
    import Vue from 'vue';

    import { UserService }from '@/services/UserService'

    export default Vue.extend({
        data() {
            return {
                isValid: true,
                showDialog: false,
                dialogMessage: "",
                showErrors: false,
                hasPassword: false,
                errors: [""],
                loading: false,
                post: null,
                emailConfirmationToken: "",
                passwordResetToken: "",
                email: "",
                password: "",
                passwordRepeat: "",
                globalPassword: "",
                showPassword: false,
            }
        },
        async created() {
            this.passwordResetToken = this.$route.query.passwordResetToken ? this.$route.query.passwordResetToken as string : "";
            this.emailConfirmationToken = this.$route.query.emailConfirmationToken ? this.$route.query.emailConfirmationToken as string : "";
            this.email = this.$route.query.email ? this.$route.query.email as string : "";

            this.$store.commit('addOverlay');
            UserService.HasPassword(this.email)
                .then((response) => {
                    if (response.data) {
                        this.hasPassword = true;
                    }

                    if (this.hasPassword && this.emailConfirmationToken) {
                        // Confirm email directly
                        this.submit();
                    }

                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
        },
        methods: {
            required(v: string): boolean | string {
                return !!v || this.$vuetify.lang.t('$vuetify.required')
            },
            matchingPasswords(v: string): boolean | string {
                    if (v === this.globalPassword) {
                        return true;
                    } else {
                        return this.$vuetify.lang.t('$vuetify.confirmUser.passwordDoesNotMatch');
                    }
                },
            async redirect() {
                this.$router.push("/");
            },
            async submit() {
                this.$store.commit('addOverlay');
                UserService.ConfirmUser({ email: this.email, password: this.password, passwordResetToken: this.passwordResetToken, emailConfirmationToken: this.emailConfirmationToken })
                    .then(() => {
                        this.dialogMessage = "";
                        if (this.emailConfirmationToken) {
                            this.dialogMessage += this.$vuetify.lang.t('$vuetify.confirmUser.emailVerifiedMessage') + " ";
                        }
                        else {
                            this.dialogMessage += this.$vuetify.lang.t('$vuetify.confirmUser.passwordUpdatedMessage') + " ";
                        }

                        this.dialogMessage += this.$vuetify.lang.t('$vuetify.confirmUser.sendingToLoginPageMessage') + " ";

                        this.showDialog = true;
                    }).catch((error) => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        } else {
                            this.errors = [this.$vuetify.lang.t('$vuetify.generalErrorMessage')];
                        }
                        this.showErrors = true;
                    }).finally(() => {
                        this.$store.commit('removeOverlay');
                    });
            }
        },
        watch: {
            password() {
                this.globalPassword = this.password;
                (this.$refs.form as Vue & { validate: () => boolean }).validate();
            },
        },
    });
